import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { fmtDate, inr } from "../../lib/format";
import { Link } from "react-router-dom";

export default function AdminPortfolios() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data));
  }, []);
  if (!data) return <div className="text-zinc-500">Loading...</div>;

  const Tbl = ({ rows, showStatus }) => (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Client</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Start</TableHead>
          <TableHead>End</TableHead>
          <TableHead>Type</TableHead>
          {showStatus && <TableHead>Status</TableHead>}
          <TableHead className="text-right">Current Value</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-zinc-500">None</TableCell></TableRow>}
        {rows.map((p) => (
          <TableRow key={p.portfolio_id}>
            <TableCell><Link className="text-zinc-950 hover:underline" to={`/admin/clients/${p.client_id}`}>{p.client?.name}</Link></TableCell>
            <TableCell className="font-mono text-sm">{p.client?.email}</TableCell>
            <TableCell className="font-mono text-sm">{fmtDate(p.start_date)}</TableCell>
            <TableCell className="font-mono text-sm">{fmtDate(p.end_date)}</TableCell>
            <TableCell>{p.is_complimentary ? "Comp." : "Paid"}</TableCell>
            {showStatus && <TableCell>
              <Badge className={p.status === "active" ? "bg-green-50 text-green-700 border-green-200" : "bg-zinc-50 text-zinc-700 border-zinc-200"}>{p.status}</Badge>
            </TableCell>}
            <TableCell className="text-right font-mono">{inr(p.current_value || 0)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-semibold">Portfolios</div>
        <h1 className="font-display font-bold text-3xl text-zinc-950 mt-1">All Portfolios</h1>
      </div>
      <Tabs defaultValue="active">
        <TabsList className="bg-zinc-100">
          <TabsTrigger value="active">Active ({data.active_count})</TabsTrigger>
          <TabsTrigger value="inactive">Inactive ({data.inactive_count})</TabsTrigger>
        </TabsList>
        <TabsContent value="active">
          <Card className="border-zinc-200 shadow-none mt-4"><CardContent className="p-0"><Tbl rows={data.active_list} /></CardContent></Card>
        </TabsContent>
        <TabsContent value="inactive">
          <Card className="border-zinc-200 shadow-none mt-4"><CardContent className="p-0"><Tbl rows={data.inactive_list} showStatus /></CardContent></Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
